/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SelectDropdown } from 'tc-client-common';
import { getSelectedFilter } from '../utils';

const getSelectedOptDocFilter = (filters) => (filtersByOptionalDocuments) =>
  getSelectedFilter(filters)(filtersByOptionalDocuments, 'optionalDocPublished', 'All actions needed');

const ActionsNeededFilter = ({ appliedFilters, onActionsNeededChange, filtersByOptionalDocuments }) => (
  <SelectDropdown
    id="optional-documents-selector"
    selectedValue={getSelectedOptDocFilter(appliedFilters)(filtersByOptionalDocuments)}
    onChange={onActionsNeededChange}
    options={filtersByOptionalDocuments}
  />
);

ActionsNeededFilter.propTypes = {
  appliedFilters: PropTypes.object,
  onActionsNeededChange: PropTypes.func,
  filtersByOptionalDocuments: PropTypes.array
};

export default ActionsNeededFilter;
